const transformImageUri = uri =>
  uri.startsWith("http") || uri.startsWith("https")
    ? uri
    : `https://api.aramaze.am${uri}`

export default transformImageUri
